import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <span className="copyright">
          © Цифрове видавництво Експертус, 2001-{new Date().getFullYear()}. Усі права захищено
        </span>
      </div>
      <div className="soc-icon-wrapper"></div>
    </footer>
  );
};
